import { useMutation } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import API_URL from '../constants/environment';

interface LoginCredentials {
  email: string;
  password: string;
}

interface LoginResponse {
  sessionId: string;
  root: string;
}

export const useSubmitLogin = () => {
  const submitLogin = async (credentials: LoginCredentials): Promise<AxiosResponse<LoginResponse>> => {
    return axios.post(`${API_URL}/account/login`, {
      ...credentials
    });
  };

  return useMutation({
    mutationFn: submitLogin,
  });
}; 